import React from 'react';
import classNameBind from 'classnames/bind';
import Item from './components/Item';
import styles from './SegmentedSelection.module.css';

const bindClasses = classNameBind.bind(styles);

const SegmentedSelection = ({
  name,
  dataId,
  equalWidth,
  fullWidth,
  onChange,
  options,
  value,
}) => {
  const createEvent = newValue => ({
    target: {
      name,
      value: newValue,
    },
  });

  return (
    <div
      className={bindClasses('wrapper', { 'full-width': fullWidth, 'equal-width': equalWidth })}
      data-ppuc-id={dataId}
    >
      {options.map((item) => {
        const itemValue = item.value || item.id;

        return (
          <Item
            onChange={() => onChange(createEvent(itemValue))}
            text={item.name || ''}
            selected={itemValue === value}
            fullWidth={fullWidth}
            key={item.id}
            id={item.id}
            value={itemValue}
            icon={item.icon || null}
            dataId={`${dataId}.item`}
            tooltip={item.tooltip || {}}
          />
        );
      })}
    </div>
  );
};

SegmentedSelection.defaultProps = {
  dataId: 'SegmentedSelection',
  equalWidth: false,
  fullWidth: false,
};

export { SegmentedSelection };
